export default {
      id: "new-file-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "icons.svg#new-file",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-file.svg
// module id = 287
// module chunks = 0